module.exports = __webpack_public_path__ + "static/img/icon_rakutan.cdd892d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_rakutan.png
// module id = e57k
// module chunks = 0